/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Popconfirm } from "antd";

const ConfirmButton = ({
  title,
  okText,
  cancelText,
  placement = 'top',
  children,
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  return (
    <Popconfirm
        icon={<></>}
        okButtonProps={{className: 'base-btn'}}
        cancelButtonProps={{className: 'base-btn base-btn--secondary'}}
        placement={placement}
        title={title}
        onConfirm={onConfirm}
        onCancel={onCancel}
        okText={okText}
        cancelText={cancelText}

    >
      {children}
    </Popconfirm>
  );
};

export default ConfirmButton;
